module.exports = __webpack_public_path__ + "static/1.1ca30819.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/1.png
// module id = 868
// module chunks = 69039249851653 261756379115546